import type { CombinedError, OperationContext, OperationResult } from "urql"
import { useMutation } from "urql"

import type { Mutation, UserMutationUpdateArgs } from "@/graphql/codegen/graphql"
import { UpdateUserDocument } from "@/graphql/codegen/graphql"

export const useUpdateUser = (): {
  update: (
    variables: UserMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "user">, UserMutationUpdateArgs>>
  fetching: boolean
  error: CombinedError | undefined
} => {
  const [{ fetching, error }, update] = useMutation<Pick<Mutation, "user">, UserMutationUpdateArgs>(UpdateUserDocument)

  return {
    update,
    fetching,
    error,
  }
}
